"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllegroExpandedPartList = isAllegroExpandedPartList;
exports.parseAllegroPartList = parseAllegroPartList;
const BoundaryLevel_1 = require("@cadstrom/sigma-engine-shared/dist/BoundaryLevel");
const AllegroTypes_1 = require("./AllegroTypes");
const EXPANDED_PARTLIST_HEADER = 'FILE_TYPE=EXPANDEDPARTLIST';
function isAllegroExpandedPartList(content) {
    const firstLine = content.split(/\r?\n/, 1)[0].trim();
    return firstLine.startsWith(EXPANDED_PARTLIST_HEADER);
}
function parseAllegroPartList(content) {
    const warnings = [];
    const lines = content.split(/\r?\n/);
    const partList = {
        directives: {},
        parts: [],
    };
    let i = 0;
    if (i < lines.length) {
        const headerLine = lines[i].trim();
        if (!headerLine.startsWith(EXPANDED_PARTLIST_HEADER)) {
            warnings.push({
                type: AllegroTypes_1.AllegroParsingMessageType.ParsingWarning,
                message: `Expected FILE_TYPE=EXPANDEDPARTLIST header, found: ${headerLine}`,
                severity: BoundaryLevel_1.BoundaryLevel.Warning,
            });
        }
        i++;
    }
    if (i < lines.length) {
        const commentLine = lines[i].trim();
        if (commentLine.startsWith('{') && commentLine.endsWith('}')) {
            partList.headerComment = commentLine.slice(1, -1).trim();
            i++;
        }
    }
    while (i < lines.length) {
        const line = lines[i].trim();
        if (!line) {
            i++;
            continue;
        }
        if (line === 'DIRECTIVES') {
            i++;
            i = parseDirectives(lines, i, partList.directives, warnings);
            continue;
        }
        break;
    }
    let currentPart;
    while (i < lines.length) {
        const line = lines[i].trim();
        if (!line || line === 'END.') {
            i++;
            continue;
        }
        if (line === 'PART_NAME') {
            i++;
            currentPart = parsePartNameBlock(lines, i, warnings);
            if (currentPart) {
                partList.parts.push(currentPart);
                i = skipPartNameProperties(lines, i, warnings);
            }
            continue;
        }
        if (line.startsWith('SECTION_NUMBER') && currentPart) {
            i++;
            i = collectSectionProperties(lines, i, currentPart, warnings);
            continue;
        }
        i++;
    }
    const processingResults = {
        type: 'allegro-parsing',
        message: warnings.length > 0 ?
            `Allegro part list parsing completed with ${warnings.length} warning(s)`
            : 'Allegro part list parsing completed',
        innerResults: warnings,
        severity: warnings.length > 0 ? BoundaryLevel_1.BoundaryLevel.Warning : BoundaryLevel_1.BoundaryLevel.Recommendation,
    };
    return { partList, processingResults };
}
function parseDirectives(lines, i, directives, warnings) {
    let propertyBuffer = '';
    while (i < lines.length) {
        const line = lines[i].trim();
        if (line === 'END_DIRECTIVES;' || line === 'END_DIRECTIVES') {
            if (propertyBuffer.trim()) {
                parsePropertyString(propertyBuffer, directives);
            }
            i++;
            break;
        }
        propertyBuffer += ' ' + line;
        if (line.endsWith(';')) {
            parsePropertyString(propertyBuffer, directives);
            propertyBuffer = '';
        }
        i++;
    }
    return i;
}
function parsePartNameBlock(lines, i, warnings) {
    while (i < lines.length) {
        const line = lines[i].trim();
        if (!line) {
            i++;
            continue;
        }
        const match = line.match(/^(\S+)\s+'([^']+)':/);
        if (match) {
            return {
                refdes: match[1],
                partName: match[2],
                properties: {},
            };
        }
        warnings.push({
            type: AllegroTypes_1.AllegroParsingMessageType.ParsingWarning,
            message: `Invalid PART_NAME line: ${line}`,
            severity: BoundaryLevel_1.BoundaryLevel.Warning,
        });
        return undefined;
    }
    return undefined;
}
function skipPartNameProperties(lines, i, _warnings) {
    i++;
    while (i < lines.length) {
        const line = lines[i].trim();
        if (!line || line === 'PART_NAME' || line.startsWith('SECTION_NUMBER') || line === 'END.') {
            break;
        }
        i++;
    }
    return i;
}
function collectSectionProperties(lines, i, part, _warnings) {
    let propertyBuffer = '';
    while (i < lines.length) {
        const line = lines[i].trim();
        if (!line) {
            i++;
            continue;
        }
        if (line === 'PART_NAME' || line.startsWith('SECTION_NUMBER') || line === 'END.') {
            break;
        }
        if (line.startsWith("'@")) {
            i++;
            continue;
        }
        propertyBuffer += ' ' + line;
        if (line.endsWith(';')) {
            parsePropertyString(propertyBuffer, part.properties);
            propertyBuffer = '';
        }
        i++;
    }
    if (propertyBuffer.trim()) {
        parsePropertyString(propertyBuffer, part.properties);
    }
    return i;
}
function parsePropertyString(raw, target) {
    const cleaned = raw.trim().replace(/;$/, '');
    const pairs = splitProperties(cleaned);
    for (const pair of pairs) {
        const trimmed = pair.trim();
        if (!trimmed) {
            continue;
        }
        const eqIndex = trimmed.indexOf('=');
        if (eqIndex === -1) {
            continue;
        }
        const key = trimmed.substring(0, eqIndex).trim();
        const value = stripQuotes(trimmed.substring(eqIndex + 1).trim());
        target[key] = value;
    }
}
function splitProperties(str) {
    const results = [];
    let current = '';
    let inQuote = false;
    for (let i = 0; i < str.length; i++) {
        const ch = str[i];
        if (ch === "'") {
            inQuote = !inQuote;
        }
        if (ch === ',' && !inQuote) {
            results.push(current);
            current = '';
        }
        else {
            current += ch;
        }
    }
    if (current.trim()) {
        results.push(current);
    }
    return results;
}
function stripQuotes(str) {
    const trimmed = str.trim();
    if (trimmed.startsWith("'") && trimmed.endsWith("'")) {
        return trimmed.slice(1, -1);
    }
    return trimmed;
}
//# sourceMappingURL=AllegroPartListParser.js.map